import { updateSharingLinkFromSharingDialog } from '../actions/internalActions';
import getSharingLink from '../selectors/getSharingLink';
import SharingLinkInfo from '../store/schema/SharingLinkInfo';
import { logUsage } from 'owa-analytics';
import { SharingDialogResponse } from 'owa-sharing-dialog';
import { orchestrator } from 'satcheljs';

orchestrator(updateSharingLinkFromSharingDialog, actionMessage => {
    const sharingLink: SharingLinkInfo = getSharingLink(actionMessage.linkId);
    if (hasAnyPropertyChanged(sharingLink, actionMessage.sharingDialogResponse)) {
        logUsage('LinkChangedFromSharingDialog');
    } else {
        logUsage('LinkUnchangedFromSharingDialog');
    }
});

function hasAnyPropertyChanged(
    sharingLink: SharingLinkInfo,
    sharingDialogResponse: SharingDialogResponse
) {
    return (
        sharingLink.url !== sharingDialogResponse.url ||
        sharingLink.permissionLevel !== sharingDialogResponse.permissionLevel ||
        sharingLink.sharingInfo.blocksDownload !== sharingDialogResponse.blocksDownload ||
        sharingLink.sharingInfo.expirationDate !== sharingDialogResponse.expirationDate
    );
}
